import React, { FC, useContext, useEffect, useState } from 'react';

import { H3, Separator, Toggle, Tooltip } from '@smartshell/ui-kit';

import { ScreenSaver, SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './SmartKiosk.module.scss';

export const SmartKiosk: FC = () => {
  const { t } = useContext(LocalizationContext);

  const {
    state: {
      settings: { screenSmartKiosk },
      isLoading,
    },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const isAvailable = useIsFeatureAvailable('shell_skin_screensaver');
  const [isShown, setIsShown] = useState(Boolean(screenSmartKiosk));

  useEffect(() => {
    setIsShown(Boolean(screenSmartKiosk));
  }, [screenSmartKiosk]);

  useEffect(() => {
    if (!isShown && screenSmartKiosk) {
      setSetting({ alias: ESettingsAliases.SHELL_SMART_KIOSK, value: '' });
    }
  }, [isShown]);

  return (
    <div className={s.container}>
      <div className={s.fields}>
        <Toggle
          onChange={setIsShown}
          value={isShown}
          label={t('setting.shell.screensaver')}
          disabled={isLoading || !isAvailable}
          variant="secondary"
          emptyBg
          className={s.toggle}
          rightContent={
            isAvailable ? (
              <Tooltip
                contentClassName={s.tooltip_content}
                content={
                  <div className={s.tooltip_frame}>
                    <H3>{t('setting.shell.screensaver.info.static')}</H3>
                    <ul className={s.tooltip_list}>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('setting.shell.bg.optimal')}
                        </span>
                        <span className={s.tooltip_value}>1920х1080</span>
                      </li>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('application.image.maxSize')}
                        </span>
                        <span className={s.tooltip_value}>
                          7 {t('setting.shell.bg.optimal.size')}
                        </span>
                      </li>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('application.image.format')}
                        </span>
                        <span className={s.tooltip_value}>
                          .jpg, .jpeg .png
                        </span>
                      </li>
                    </ul>
                    <Separator />
                    <H3>{t('setting.shell.screensaver.info.dynamic')}</H3>
                    <ul className={s.tooltip_list}>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('setting.shell.bg.optimal')}
                        </span>
                        <span className={s.tooltip_value}>1920х1080</span>
                      </li>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('application.image.maxSize')}
                        </span>
                        <span className={s.tooltip_value}>
                          30 {t('setting.shell.bg.optimal.size')}
                        </span>
                      </li>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('application.image.format')}
                        </span>
                        <span className={s.tooltip_value}>.mp4, .webm</span>
                      </li>
                    </ul>
                  </div>
                }
              />
            ) : (
              <SettingsLock />
            )
          }
        />
        <Separator style={{ margin: '8px 0' }} />
      </div>
      <ScreenSaver
        disabled={!isAvailable || !isShown}
        type="smart_kiosk"
        group="none"
      />
    </div>
  );
};
